











import { Vue, Prop, Component } from 'vue-property-decorator'
import Collocation from './collocation.vue'
@Component({
  components: {
    Collocation,
  },
})
export default class goodsSalesList extends Vue {
  @Prop({ default: [] }) collocationList: any[]

  get collocationInfo() {
    return this.collocationList[0]
  }
}
